<script>
  // # # # # # # # # # # # # #
  //
  //  Tag list
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { Router, links } from "svelte-routing";

  // *** PROPS
  export let item;
</script>

<style lang="scss">
  @import "../_variables.scss";

  .tag-list {
    font-family: "Akkurat-Mono", "Courier New", Courier, monospace;
    font-size: 11px;
    line-height: 1em;
    margin-bottom: 1em;

    &__tag-item {
      border-bottom: none;
      color: currentColor;
      display: inline-block;
      height: 100%;
      padding-bottom: $small-margin * 0.5;
      margin-bottom: $small-margin * 1.5;
      margin-right: $small-margin * 2;
      text-transform: uppercase;
      white-space: nowrap;
      border-bottom: 1px solid currentColor;

      @include normal-hover-state;

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>

<Router>
  <div class="tag-list" use:links>
    {#if item.header.taxonomy}
      {#each item.header.taxonomy.tag as tag}
        <a href="/tags/{tag}" class="tag-list__tag-item">{tag}</a>
      {/each}
    {/if}
  </div>
</Router>
